export const projects = [
	{
		title: 'Gaming Hub',
		description: `💻E-commerce project - Completed in 1 month, this store of digital products features:

👉 The ability to buy products with 2 card payment methods
👉 User login/registration with different platforms
👉 Mini Cart that persists throughout sessions 
👉 Responsive layout
👉 Admin Page with statistics
👉 Automatic Email messages

🔨 React, Redux, Express, Sequelize, Firebase & Passport.`,
		live: 'https://ecommerce-ft07-g07.vercel.app/',
		repo: 'https://github.com/tinsanchez00',
		img: 'imgs/gaminghub2.png',
	},
	{
		title: 'QuizMeApp',
		description: `📱Mobile App - Completed in 3 weeks, this fun app features:

👉 Different quizzes from the community that you can play
👉 The ability to create your own quiz
👉 Quizzes recommedations based on what you've played
👉 You can follow your friends and see their quizzes
👉 A leaderboard for each quiz
👉 Achivements

🔨 React Native, Redux Toolkit, Express, MongoDB, GraphQL, Apollo, Passport, Firebase`,
		live: 'https://appgallery.huawei.com/#/app/C103845919',
		repo: 'https://github.com/tinsanchez00',
		img: 'imgs/QuizMeApp.jpg',
	},
];
export default projects;
